export const PWA_INSTALL_PROMPT_DISMISS_KEY = 'dohockey.pwa.installPromptDismissedAt';
export const LEGACY_PWA_INSTALL_PROMPT_DISMISS_KEY = 'pwa_prompt_dismissed';

const DISMISS_KEYS = [
  PWA_INSTALL_PROMPT_DISMISS_KEY,
  LEGACY_PWA_INSTALL_PROMPT_DISMISS_KEY,
] as const;

export const isPwaInstallPromptDismissed = (storage: Storage): boolean =>
  DISMISS_KEYS.some(key => Boolean(storage.getItem(key)));

export const dismissPwaInstallPrompt = (storage: Storage): void => {
  storage.setItem(PWA_INSTALL_PROMPT_DISMISS_KEY, 'dismissed');
};

export const clearStoragePreservingPwaInstallPreference = (storage: Storage): void => {
  const preserved = DISMISS_KEYS
    .map(key => [key, storage.getItem(key)] as const)
    .filter((entry): entry is readonly [typeof DISMISS_KEYS[number], string] => entry[1] !== null);

  storage.clear();
  preserved.forEach(([key, value]) => storage.setItem(key, value));
};
